<template>
  <div class="work-list-page">
    <SupportPageCard
      page-class="work-list"
      :title="languages.mylist_headerTitle"
      :show-back="leftArrow"
      :show-lang-choose="leftArrow"
      @back="back"
    >
    <template #toolbar>
      <van-form class="work-list-search">
        <van-search
          ref="search"
          class="search"
          :placeholder="languages.inputWorkSearch"
          background="transparent"
          clearable
          clear-trigger="always"
          v-model="originSearchValue"
          :show-action="visibleSearchCancel"
          @clear="() => onInput({ target: { value: '' } })"
        >
          <template #left-icon>
            <div></div>
          </template>
          <template #right-icon>
            <van-icon v-if="!searchValue" name="search" />
          </template>
        </van-search>
      </van-form>
    </template>

    <div class="work-list-main">
      <van-pull-refresh
        class="list"
        v-model="refreshingList"
        :disabled="loadingList"
        :pulling-text="' '"
        :loosing-text="' '"
        @refresh="onRefreshList"
      >
        <van-list
          v-model="loadingList"
          :finished="finishedList"
          :error.sync="errorLoad"
          :loading-text="languages.loading"
          :error-text="languages.loadingError"
          :finished-text="languages.noMore"
          @load="onLoadList"
        >
          <WorkItem
            v-for="(item, index) in workList"
            :key="item.SUPPORT_ORDER_ID"
            :workItem="item"
            :index="index"
            :visibleControl="item.visibleControl"
            :transitionDelay="item.transitionDelay"
            @updateVisibleControl="updateVisibleControl"
            @topWorkItem="topWorkItem(item, index)"
            @cancelWorkItem="beforeCancelConfirm(item, index)"
          ></WorkItem>
        </van-list>
      </van-pull-refresh>
    </div>

    <template #footer>
      <div ref="createAnchor" class="work-list-create">
        <van-button
          class="work-list-create-btn"
          round
          block
          type="info"
          @click="contactService"
        >
          <template #icon>
            <em class="btn-icon iconfont icon-info"></em>
          </template>
          <template
            >{{ languages.smartOrderContactService
            }}<span class="beta" v-if="isLogin && isJumpAiBot"
              >BETA</span
            ></template
          >
        </van-button>
      </div>
    </template>

    <template #overlay>
      <van-action-sheet
        v-model="visibleCancelConfirm"
        :closeable="false"
        @closed="successDel"
      >
        <div class="sheet">
          <div class="sheet-confirm">
            <div class="sheet-confirm-top">
              <p>&nbsp</p>
              <p>{{ languages.confirmDelWorkTop }}</p>
              <p class="delete">{{ languages.confirmDelWorkBottom }}</p>
            </div>
            <div class="sheet-confirm-bottom">
              <van-button class="cancel" @click="cancelDel">
                {{ languages.cancel }}
              </van-button>
              <van-button
                class="confirm"
                @click="cancelWorkItem"
                :loading="delWorkItem.loadingDelete"
              >
                {{ languages.mywork_confirm }}
              </van-button>
            </div>
          </div>
        </div>
      </van-action-sheet>
    </template>
  </SupportPageCard>
  <!-- 原位按钮离开视口时吸底；挂 body 避免 PC transform 影响 fixed -->
  <div
    v-show="showFloatCreate"
    ref="createFloat"
    class="work-list-create-float"
    :class="floatCreateClass"
  >
    <van-button
      class="work-list-create-btn"
      round
      block
      type="info"
      @click="contactService"
    >
      <template #icon>
        <em class="btn-icon iconfont icon-info"></em>
      </template>
      <template
        >{{ languages.smartOrderContactService
        }}<span class="beta" v-if="isLogin && isJumpAiBot">BETA</span></template
      >
    </van-button>
  </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import SupportPageCard from '@components/officialSupport/common/SupportPageCard.vue';
import WorkItem from '@components/officialSupport/WorkItem.vue';
import globalConfig from '@utiles/globalConfig';
import { getSupportThemeClass } from '@utiles/officialSupport/theme';
import { isPhone } from '@utiles/device';
import {
  clickButton,
  locationType
} from '@plugins/biPoint/_configOfficialSupport';
import pointStayTime from '@mixins/officialSupport/pointStayTime';
import aiBot from '@mixins/officialSupport/aiBot';
export default {
  name: 'MyWorkList',
  mixins: [pointStayTime, aiBot],
  data() {
    return {
      page: 1,
      pageSize: 10,
      originSearchValue: undefined,
      searchValue: undefined, // 搜索关键字
      visibleSearchCancel: false, // 是否显示搜索的取消按钮
      refreshingList: false, // 刷新工单列表
      loadingList: false, // 加载工单列表中
      finishedList: false, // 工单列表数据全部加载完
      workList: [], // 工单列表数据
      errorLoad: false,
      timer: null,
      visibleCancelConfirm: false,
      delWorkItem: {
        loadingDelete: false,
        index: undefined,
        data: undefined,
        succDel: false
      },
      // 吸底浮层：竖屏 phone 常驻；PC/横屏由 IO 控制显隐
      showFloatCreate: false,
      enableFloatCreate: false
    };
  },
  computed: {
    ...mapState({
      languages: state => state.languages,
      letter: state => state.languages?.mylist,
      faqSiteName: state => state.faqSiteName,
      faqClassList: state => state.faqClassList,
      workTempList: state => state.workTempList,
      isLogin: state => state.isLogin,
      urlParams: state => state.urlParams
    }),
    themeClass() {
      const gameId =
        this.urlParams?.gameId ||
        globalConfig.getHrefParam('gameId') ||
        globalConfig.getHrefParam('gameID') ||
        globalConfig.getHrefParam('game_id') ||
        '';
      return getSupportThemeClass(gameId);
    },
    floatCreateClass() {
      return [this.themeClass, { 'is-pc': !isPhone() }];
    },
    leftArrow() {
      const gameId =
        globalConfig.getHrefParam('gameId') ||
        globalConfig.getHrefParam('gameID') ||
        globalConfig.getHrefParam('game_id');
      if (!gameId) {
        return false;
      }
      if (this.faqClassList.length === 0 && this.workTempList.length === 0) {
        return false;
      }
      return true;
    }
  },
  watch: {
    workList() {
      this.$nextTick(() => {
        this.refreshCreateFloatObserver();
      });
    }
  },
  methods: {
    ...mapActions(['getWorkList', 'setOrderToTop', 'deleteOrder']),
    isFloatCreateEnabled() {
      return typeof window !== 'undefined';
    },
    /** 竖屏 phone：联系客服常驻 fixed，避开 Safari 安全区挡住 footer */
    isPortraitPhoneFloatAlways() {
      return (
        isPhone() &&
        typeof window !== 'undefined' &&
        window.matchMedia('(orientation: portrait)').matches
      );
    },
    mountCreateFloatToBody() {
      const floatEl = this.$refs.createFloat;
      if (floatEl && floatEl.parentNode !== document.body) {
        document.body.appendChild(floatEl);
      }
    },
    teardownCreateFloatObserver() {
      if (this._createFloatObserver) {
        this._createFloatObserver.disconnect();
        this._createFloatObserver = null;
      }
    },
    refreshCreateFloatObserver() {
      this.teardownCreateFloatObserver();
      this.enableFloatCreate = this.isFloatCreateEnabled();
      if (!this.enableFloatCreate) {
        this.showFloatCreate = false;
        return;
      }
      this.mountCreateFloatToBody();
      // 竖屏 phone：进页即常驻吸底，不依赖 IO（footer 在视口内但会被安全区挡住）
      if (this.isPortraitPhoneFloatAlways()) {
        this.showFloatCreate = true;
        return;
      }
      // PC / 横屏：原位进视口藏浮层，离开则吸底
      this.showFloatCreate = true;
      const anchor = this.$refs.createAnchor;
      if (!anchor || typeof IntersectionObserver === 'undefined') {
        return;
      }
      this._createFloatObserver = new IntersectionObserver(
        entries => {
          const entry = entries[0];
          if (!entry || !this.enableFloatCreate) {
            this.showFloatCreate = false;
            return;
          }
          this.showFloatCreate = !entry.isIntersecting;
        },
        {
          root: null,
          threshold: 0,
          rootMargin: '0px'
        }
      );
      this._createFloatObserver.observe(anchor);
    },
    onCreateFloatViewportChange() {
      this.refreshCreateFloatObserver();
    },
    back() {
      if (globalConfig.isTiktokMiniProgram()) {
        this.$router.push('/workhome');
      } else {
        this.$router.go(-1);
      }
    },
    // 监听原生搜索框input时间
    listenerSearchInput() {
      const searchRef = this.$refs?.search;
      const searchRoot = searchRef?.$el || searchRef;
      const searchInputEle = searchRoot?.querySelector?.(
        '.van-field__control'
      );
      if (searchInputEle) {
        searchInputEle.addEventListener('input', this.onInput);
      }
    },
    // 取消监听原生搜索框input时间
    unListenerSearchInput() {
      const searchRef = this.$refs?.search;
      const searchRoot = searchRef?.$el || searchRef;
      const searchInputEle = searchRoot?.querySelector?.(
        '.van-field__control'
      );
      if (searchInputEle) {
        searchInputEle.removeEventListener('input', this.onInput);
      }
    },
    // 搜索，点击清空按钮也会触发该事件
    onInput(e) {
      const value = e?.target?.value;
      this.searchValue = value;
      clearTimeout(this.timer);
      this.timer = setTimeout(
        async () => {
          this.refreshingList = true;
          try {
            window.scrollTo(0, 0);
          } catch (e) {
            console.error(e);
          }
          await this.onRefreshList();
        },
        value === void 0 || value === '' ? 0 : 600
      );
    },
    updateVisibleControl(bool, index) {
      for (let i = 0, len = this.workList.length; i < len; i++) {
        this.workList[i].visibleControl = false;
      }
      this.workList[index].visibleControl = bool;
    },
    addControlParams(obj) {
      if (obj) {
        return Object.assign(obj, { visibleControl: false });
      }
      return obj;
    },
    // 重新加载工单列表
    async onRefreshList() {
      // console.log('onRefreshList');
      // 表示可以重新加载数据
      this.finishedList = false;
      // 重新加载数据,将 loadingList 设置为 true，表示处于加载状态
      this.loadingList = true;
      // 开始加载
      await this.onLoadList();
      return Promise.resolve();
    },
    // 加载工单列表
    async onLoadList() {
      // console.log('onLoadList');
      // 是刷新列表，重置初始化数据
      if (this.refreshingList) {
        this.page = 1;
        this.workList = [];
        this.refreshingList = false;
      }
      try {
        if (this.searchValue) {
          window.csorderDataLayer.push({
            eventName: 'orderSearch',
            eventValue: {
              text: this.searchValue || ''
            }
          });
        }
        const submitKeyword =
          this.searchValue && this.searchValue.trim() !== ''
            ? this.searchValue
            : '';
        const data = await this.getWorkList({
          keyword: submitKeyword,
          page: this.page,
          page_size: this.pageSize
        });
        const newData = data?.LIST?.length ? data.LIST : [];
        const decorateNewData = [];
        for (let i = 0, len = newData.length; i < len; i++) {
          const item = newData[i];
          item.visibleControl = false; // 控制置顶和删除操作是否显示
          item.transitionDelay = i * 0.2; // 动画延迟加载 0.2s * 索引值
          decorateNewData.push(item);
        }
        this.workList.push(...newData);
        if (
          data?.TOTAL == this.workList.length ||
          !data?.LIST?.length ||
          data?.LIST?.length <= 0
        ) {
          // 表示全部数据加载完成
          this.finishedList = true;
        }
        this.page++;
        // 表示本次加载完成，这个计算是等插入动画完成后才是加载完成
        await new Promise(resolve => {
          setTimeout(() => {
            this.loadingList = false;
            resolve();
          }, newData.length * 200);
        });
      } catch (e) {
        console.log(e);
        // 触发加载失败
        this.loadingList = false;
        this.errorLoad = true;
      }
      return Promise.resolve();
    },
    goToCreateWork() {
      clickButton({
        btnName: 'clickCreateOrder',
        locationKey: locationType.orderListPage
      });
      this.$router.push({
        path: '/creatework',
        query: {
          source: 'orderlist'
        }
      });
    },
    async topWorkItem(item, index) {
      try {
        if (item.IS_TOP == 1) {
          clickButton({
            btnName: 'clickCancelTopWorkItem',
            locationKey: locationType.orderListPage,
            otherParams: {
              workId: item.SUPPORT_ORDER_ID
            }
          });
        } else {
          clickButton({
            btnName: 'clickTopWorkItem',
            locationKey: locationType.orderListPage,
            otherParams: {
              workId: item.SUPPORT_ORDER_ID
            }
          });
        }
        await this.setOrderToTop({
          orderId: item.SUPPORT_ORDER_ID,
          isTop: item.IS_TOP == 1 ? 0 : 1
        });
        this.refreshingList = true;
        this.onRefreshList();
      } catch (e) {
        console.log(e);
      }
    },
    beforeCancelConfirm(item, index) {
      this.delWorkItem.data = item;
      this.delWorkItem.index = index;
      this.visibleCancelConfirm = true;
    },
    cancelDel() {
      this.visibleCancelConfirm = false;
    },
    successDel() {
      if (this.delWorkItem.succDel) {
        this.workList.splice(this.delWorkItem.index, 1);
        this.delWorkItem.succDel = false;
        this.delWorkItem.data = undefined;
        this.delWorkItem.index = undefined;
        clickButton({
          btnName: 'clickConfirmDeleteWorkItem',
          locationKey: locationType.orderListPage,
          otherParams: {
            workId: this.delWorkItem.data?.SUPPORT_ORDER_ID
          }
        });
      }
    },
    async cancelWorkItem() {
      this.delWorkItem.loadingDelete = true;
      try {
        await this.deleteOrder({
          orderId: this.delWorkItem.data?.SUPPORT_ORDER_ID
        });
        this.delWorkItem.succDel = true;
        this.cancelDel();
      } catch (e) {
        console.log(e);
        this.delWorkItem.succDel = false;
      }
      this.delWorkItem.loadingDelete = false;
    },
    contactService() {
      clickButton({
        btnName: 'clickCreateOrder',
        locationKey: locationType.orderListPage,
        otherParams: {
          frontVersion: `v1_${new Date().getTime()}`,
          isOpenAiEntrance: this.isJumpAiBot,
          isLogin: this.isLogin
        }
      });
      this.handleContactService('orderlist');
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.listenerSearchInput();
      this.refreshCreateFloatObserver();
    });
    window.addEventListener('orientationchange', this.onCreateFloatViewportChange);
    window.addEventListener('resize', this.onCreateFloatViewportChange);
  },
  beforeDestroy() {
    this.unListenerSearchInput();
    this.teardownCreateFloatObserver();
    window.removeEventListener(
      'orientationchange',
      this.onCreateFloatViewportChange
    );
    window.removeEventListener('resize', this.onCreateFloatViewportChange);
    // 移回组件内，避免 Vue 卸载时节点已不在原父级
    const floatEl = this.$refs.createFloat;
    if (floatEl && this.$el && floatEl.parentNode === document.body) {
      this.$el.appendChild(floatEl);
    }
  },
  beforeMount() {
    this.unListenerSearchInput();
  },
  beforeRouteLeave(to, from, next) {
    if (to.path === '/worktemp') {
      next('/workhome');
      return;
    }
    if (
      to.path === '/workhome' &&
      this.faqClassList.length === 0 &&
      this.workTempList.length === 0
    ) {
      return;
    }
    next();
  },
  components: {
    SupportPageCard,
    WorkItem
  }
};
</script>
